import { render } from "./MainContainer.vue?vue&type=template&id=5fc89354"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__